import React from 'react';

const WebProducts = props => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', background: '#FFF' }}>
      <div class="relative bg-black">
        <div class="px-10 py-6 relative max-w-screen-xl mx-auto flex items-center justify-between">
          <div class="inline-flex">
            <h2 class="tracking-wide font-extrabold max-w-5xl mx-auto text-white text-4xl">
              Choose Your Plan - <span class="text-yellow">ESID 1234567897</span>
            </h2>
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '12px 24px',
          margin: '24px 0'
        }}
      >
        {props.webProducts.map(product => (
          <div class="mx-4">
            <div class="border-2 border-black rounded-lg shadow-sm divide-y divide-gray-200">
              <div class="p-7">
                <h2 class="text-2xl leading-6 font-extrabold text-black">{product.name}</h2>
                <p class="mt-2 text-sm leading-5 text-gray-500"> {product.description} </p>
                <p class="mt-8">
                  <span class="text-5xl leading-10 font-extrabold text-gray-900">
                    {' '}
                    ${product.kwh0500Price}{' '}
                  </span>
                  <span class="text-base leading-6 font-medium text-gray-500">/kWh</span>
                </p>
                <button
                  type="button"
                  class="py-6 mt-8 w-full bg-yellow border rounded-md text-xl leading-5 font-semibold text-white hover:bg-black focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out"
                  onClick={() => props.setWebProduct(product)}
                >
                  Select - {product.name}
                </button>
              </div>
              <div class="bg-yellow bg-opacity-10 rounded-b-lg pt-6 pb-8 px-6">
                <h3 class="leading-4 font-bold text-gray-900 tracking-wide uppercase">
                  What's included
                </h3>
                <ul class="mt-6 space-y-4">
                  <li class="flex space-x-3">
                    <svg
                      class="flex-shrink-0 h-5 w-5 text-green-500"
                      aria-hidden="true"
                      x-description="Heroicon name: check"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span class="text-sm leading-5 text-gray-500">
                      {' '}
                      {product.productDisplayFeature1}{' '}
                    </span>
                  </li>
                  <li class="flex space-x-3">
                    <svg
                      class="flex-shrink-0 h-5 w-5 text-green-500"
                      aria-hidden="true"
                      x-description="Heroicon name: check"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span class="text-sm leading-5 text-gray-500">
                      {' '}
                      {product.productDisplayFeature2}{' '}
                    </span>
                  </li>
                  <li class="flex space-x-3">
                    <svg
                      class="flex-shrink-0 h-5 w-5 text-green-500"
                      aria-hidden="true"
                      x-description="Heroicon name: check"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span class="text-sm leading-5 text-gray-500">
                      {' '}
                      {product.productDisplayFeature3}{' '}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div class="mb-8 flex justify-center">
        <button class="bg-white hover:opacity-75 text-black border-4 hover:shadow-lg border-black hover:bg-yellow hover:text-white hover:border-white transition ease-in-out duration-150">
          <div class=" inline-flex">
            <div class="h-auto ">
              <div class="p-7">
                <h2 class="text-3xl leading-6 font-extrabold">WHOLESALE</h2>
                <p class="mt-2 text-xl leading-5"> (12-month) </p>
              </div>
              <div class="w-full text-center bg-gradient-to-b from-red-500 to-yellow  pt-6 pb-10 px-6">
                <p class="mt-8 mb-8 ">
                  <span class="text-7xl leading-10 font-extrabold text-white ">$0.124</span>
                  <span class="text-base leading-6 font-medium text-white">/kWh</span>
                </p>
                <p class="max-w-lg font-medium leading-1 text-white text-xl">
                  With this option, you’ll pay for your electricity usage for the entire year. Your
                  wholesale rate is determined by how much you estimate your kWh usage will be + our
                  Addr rate. This is a luxury item and will cost a bit more but our mission is still
                  to save you energy and money in the long run.
                </p>
              </div>
            </div>
          </div>
        </button>
        <button class="ml-8 bg-white hover:opacity-75 text-black border-4 hover:shadow-lg border-black hover:bg-yellow hover:text-white hover:border-white transition ease-in-out duration-150">
          <div class=" inline-flex">
            <div class="h-auto ">
              <div class="p-7">
                <h2 class="text-3xl leading-6 font-extrabold">POST PAY</h2>
                <p class="mt-2 text-xl leading-5"> (month to month) </p>
              </div>
              <div class="w-full text-center bg-gradient-to-b from-red-500 to-yellow  pt-6 pb-10 px-6">
                <p class="mt-8 mb-8 ">
                  <span class="text-7xl leading-10 font-extrabold text-white ">$0.032</span>
                  <span class="text-base leading-6 font-medium text-white">/kWh</span>
                </p>
                <p class="max-w-lg pb-1.5 font-medium leading-1 text-white text-xl">
                  With this option, you will receive your energy usage bill from us at the end of
                  every month. You can check your usage via our website or app. Your rate is
                  determined by how many kWh you used + our Addr rate. It’s that simple.
                </p>
                <br></br>
              </div>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};
export default WebProducts;
